import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
    selector: 'pay-empty',
    template: '',
    imports: [
        CommonModule
    ]
})

/**
 * Empty view component.
 *
 * @example
 * <pay-empty>;
 * </pay-empty>
 *
 */
export class EmptyComponent {}